// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"30826":"1ddc7ae2e620b3c9","79548":"88a01d9caad37ed9"}[chunkId] + ".css";
};